import { Instrument as InstrumentBase } from '../../bases/instrument';
import * as CONSTANTS from './constants';
import { globalScope } from '../../window/browser';
import { Aggregator } from './aggregator';

export class Instrument extends InstrumentBase {
  static featureName = CONSTANTS.FEATURE_NAME;

  constructor() {
    const aggregator = new Aggregator();

    super(aggregator, Instrument.featureName);
    this.isTraceSent = false;
    this.sendSpan = this.sendSpan.bind(this);

    if (this.loadFunctions) {
      this.loadPublicFunctions();
    }
  }

  loadPublicFunctions() {
    if (globalScope.WMANS) {
      globalScope.WMANS.session_trace = {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        send: this.sendSpan,
      };
    }
  }

  sendSpan() {
    if (this.isTraceSent) {
      return;
    }

    const attributes = this.aggregator.getSharedContext();

    if (globalScope.WMANS?.recordSpan) {
      globalScope.WMANS.recordSpan(
        'session_trace',
        [{ name: 'page_loaded', attributes: [] }],
        attributes,
        true,
      );
      this.isTraceSent = true;
    }
  }
}
